export default (id) => (state) => {
    if (id) {
        const territoriesList = state.territories.get('territories').list;
        return territoriesList.find(territory => territory.id.toString() === id.toString()) || null;
    }

    return null;
}

